// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__t9ueb","name":"Header_name__3f_rS","birthday":"Header_birthday__3Ves8","skeleton":"Header_skeleton__L7fDh"};